module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/70.9fd6792b.png";